import Video from 'app/components/tv/models/video';
import {SelectedDistrictPartialReduxState} from 'app/components/tv/apiResources/DistrictResource';
import {LayoutMode} from 'app/styles/LayoutMode';

type VideoAdKeywordsPart = {
  competition: string | null;
  homeTeam: string | null;
  awayTeam: string | null;
  video_provider: string;
};

type UserAdKeywordsPart = {
  region: string;
  district: string;
};

export type NativeVASTKeywords = {
  an?: string;
  msid?: string;
  platform?: 'android' | 'ios';
};

export type AdKeywordsInterface = VideoAdKeywordsPart & UserAdKeywordsPart & NativeVASTKeywords & {source: string};

export default class AdKeywords {
  static fromVideo(video: Video): VideoAdKeywordsPart {
    return {
      competition: video.match?.competition.slug ?? null,
      homeTeam: video.match?.homeTeam?.clubSlug ?? null,
      awayTeam: video.match?.awayTeam?.clubSlug ?? null,
      video_provider: video.category,
    };
  }

  static fromUserDistrict(userDistrict: SelectedDistrictPartialReduxState): UserAdKeywordsPart {
    return {
      region: userDistrict?.region?.slug || 'global',
      district: userDistrict.slug || 'global',
    };
  }

  static combine(
    video: Video,
    keywords: {
      userDistrict: SelectedDistrictPartialReduxState;
      nativeVASTKeywords: NativeVASTKeywords;
      layout: LayoutMode;
    }
  ): AdKeywordsInterface {
    const layout = keywords.layout === LayoutMode.Mobile ? LayoutMode.Mobile : LayoutMode.Desktop;
    const source = keywords.nativeVASTKeywords?.platform
      ? `app/${keywords.nativeVASTKeywords?.platform}`
      : `web/${layout}`;
    return {
      ...AdKeywords.fromVideo(video),
      ...AdKeywords.fromUserDistrict(keywords.userDistrict),
      ...keywords.nativeVASTKeywords,
      source,
    };
  }
}
